import { startIntl } from '../../modules/international/_intl';
import { topCatKeyboard_ADA } from '../../modules/global/_topCatKeyboard_ADA';
import { buildDropdownLinks } from './_buildDropdownLinks';
import { stickyMenu } from './_stickyMenu';
import { oneTapTwotaps } from './_oneTapTwoTaps';
import { checkCookie } from './_cookies';
import { setDesktopMenuColumns } from '../layout/_mainNav';

export const buildDropdown = () => {
	var $dropdownNavToAppend = $('#nav-append');
	if ($dropdownNavToAppend.length > 0) {
		$.ajax({
			type: 'GET',
			url: '/html/dropdown.json?v=' + window.dropdownCacheCallVariable,
			dataType: 'json',
			success: function (response) {
				try {
					if (response && typeof response === 'object') {
						buildDropdownLinks(response);
						stickyMenu();
						if (Dillards.config.deviceClass === 'tabletPage') oneTapTwotaps();
						checkCookie();
						startIntl();
						if ($('.desktopPage').length > 0) topCatKeyboard_ADA();
					}
				} catch (e) {
					console.log(e);
				}
			},
			error: function (jqXHR, textStatus, errorThrown) {
				console.log(jqXHR, textStatus, errorThrown);
			},
		});
	}
};
